"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonAccordion = void 0;
const React = require("react");
const BronsonAccordion = (props) => {
    return (React.createElement("div", { className: 'c-accordion', "data-tr-component": 'Accordion', "data-tr-state": 'Collapsed' }, props.config.rows.map((row) => row)));
};
exports.BronsonAccordion = BronsonAccordion;
